let userCode = [
  { name: "角色管理", code: "jsgl", path: "/roleManage" },
  { name: "角色权限管理", code: "jsqxgl", path: "/rolePer" },
  { name: "财务管理", code: "cwgl", path: "/financial" },
  { name: "硬件产品销售一览表", code: "tjcp", path: "/sale" },
  { name: "生产车间", code: "sccj", path: "/production" },
  { name: "商品类型", code: "cpxx", path: "/productType" },
  { name: "产品信息", code: "cpxx", path: "/producMation" },
  { name: "存货仓库", code: "chck", path: "/warehouse" },
  { name: "物料信息", code: "wlxx", path: "/materInfor" },
  { name: "推广单位", code: "tgdw", path: "/promoUnit" },
  { name: "商城订单", code: "scdd", path: "/shopOrder" },
  { name: "物料管理", code: "wlgl", path: "/material" },
  { name: "库存管理", code: "kcgl", path: "/stock" },
  { name: "售后管理", code: "shgl", path: "/afterSales" },
  { name: "退货管理", code: "thgl", path: "/returnGoods" },

  { name: "产品定价", code: "cpdj", path: "/price" },
  { name: "入库明细表", code: "rkmx", path: "/detailed" },
  { name: "入库汇总表", code: "rkhzb", path: "/summary" },
  { name: "出库明细表", code: "xsmxb", path: "/salesDetails" },
  { name: "出库汇总表", code: "xshzb", path: "/salesSummary" },
  { name: "库存报表", code: "kcbb", path: "/stockForm" },
  { name: "库存盘点表", code: "kcpdb", path: "/inventoryCheck" },
  { name: "进销存明细表", code: "jxcmxb", path: "/saleDetails" },
  { name: "进销存汇总表", code: "jxchzb", path: "/PurSalessummary" },

  { name: "客户管理", code: "khgl", path: "/customer" },

  // { name: "VIP", code: "vip", path: "/vip" },
  { name: "鸿利及绩效管理", code: "hl", path: "/hongli" },
  // { name: "鸿利充值", code: "hlcz", path: "/hongliRecharge" },
  // { name: "星云及绩效", code: "xyjjx", path: "/achievements" },

  // { name: "财务日志", code: "cwrz", path: "/financialLog" },
  { name: "开通日志", code: "ktrz", path: "/openingLog" },
  { name: "激活日志", code: "jhrz", path: "/activationLog" },
  { name: "操作日志", code: "czrz", path: "/deliveryLog" },
];
export default userCode;
